import { Alert, Box, CircularProgress, Typography } from '@mui/material';

export default function CustomerNumberChecker({
  isChecking,
  duplicateCustomerNumbers,
}) {
  if (isChecking) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          color: 'text.secondary',
          p: 1,
          mt: 1,
        }}
      >
        <CircularProgress size={20} />
        <Typography variant="body2">
          Prüfe Hauptfirma in Zielsystemen...
        </Typography>
      </Box>
    );
  } else if (duplicateCustomerNumbers.length > 0) {
    return (
      <Alert
        severity="warning"
        icon={false}
        sx={{
          display: 'flex',
          flexWrap: 'nowrap',
          width: '100%',
          py: 0,
          px: 1,
          '& .MuiAlert-message': {
            display: 'flex',
            width: '100%',
            flexDirection: 'row',
            alignItems: 'center',
          },
        }}
      >
        <Typography variant="body2" noWrap sx={{ flex: 1 }}>
          Die Kundennummer wird bereits verwendet:&nbsp;
          {Array.from(
            duplicateCustomerNumbers
              .map((obj) => obj.source)
              .reduce((m, l) => m.set(l, (m.get(l) || 0) + 1), new Map()),
          )
            .map(([l, c]) => (c > 1 ? `${l} (${c})` : l))
            .join(', ')}
        </Typography>
      </Alert>
    );
  }
}
